import { BarChart2, Package, Users } from "lucide-react";
import "./TemporaryView.css";

const ICONS = {
  SALES_REPORTS: BarChart2,
  PRODUCTS: Package,
  USERS: Users,
};

export default function TemporaryView({ type }) {
  const Icon = ICONS[type] || BarChart2;

  return (
    <div className="admin-temporary-view">
      <Icon size={48} color="#d1d5db" />
      <h3>{type.replace("_", " ")}</h3>
      <p>Coming Soon</p>
    </div>
  );
}
